import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { SalaryList } from "./SalaryList";
import { SalaryActions } from "./SalaryActions";
import Loader from "components/Loader";
import { Pagination } from "react-bootstrap";
import { mobileScroll } from "common/FunctionUtils";

const Salaries = ({ tabValue }) => {
  const { t } = useTranslation();
  const pageCount = 10;
  const [totalCount, setTotalCount] = useState();
  const [activePagination, setactivePagination] = useState(1);
  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState({
    id: 0,
    salaryType: "",
    PDFModal: false,
    viewDetails: false,
  });

  const [promiseState, setPromiseState] = useState({
    pending: false,
    fulfilled: false,
    rejected: false,
  });

  const fetchSalary = async () => {
    try {
      setPromiseState({ pending: true });
      const res = await axios.get(
        `/Salary?PageSize=${pageCount}&PageNumber=${activePagination}`
      );
      setPromiseState({ fulfilled: true });
      setSalaries(res.data.response);
      setTotalCount(res.data.totalCount);
    } catch (err) {
      setPromiseState({ rejected: true });
      setSalaries([]);
    }
  };

  let items = [];
  let paginationNumber = totalCount / pageCount;
  for (let number = 1; number <= Math.round(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  useEffect(() => {
    fetchSalary();
  }, [pageCount, activePagination]);

  useEffect(() => {
    if (tabValue === "salaries") {
      setactivePagination(1);
    }
  }, [tabValue]);

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="page-content salaries">
        <div className="pay-checks">
          <h4 className="accident_ins font-weight-bold">
            {t("Your salaries")}
          </h4>
          <p>
            <span>{t("salhere")}</span>
          </p>
        </div>
      </div>

      <SalaryList
        Salaries={salaries}
        t={t}
        setShow={setShow}
        promiseState={promiseState}
        items={items}
        activePagination={activePagination}
        pageCount={pageCount}
      />

      <SalaryActions
        t={t}
        show={show}
        setShow={setShow}
        setLoading={setLoading}
      />
    </>
  );
};

export default Salaries;
